export default "__VITE_ASSET__CDKM3FWJ__";